module.exports = __webpack_public_path__ + "img/person.a9977a35.png";